import React, { Fragment } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Header from '../containers/global/Header';

/**
 * Private routes - pass through this first and check the
 * currentUser state to see if they are authenticated. If so
 * use Outlet, this will propagate to the requested route,
 * else we will direct back to the public route login screen
 * at /auth.
 */
const PrivateRoute = ({ isAuthenticated, location }) =>
  isAuthenticated ? (
    <Fragment>
      <div className="wrapper">
        <Header />
        <div className="wrapper-content">
          <Outlet /> {/* Display the child element passed in the route */}
        </div>
      </div>
    </Fragment>
  ) : (
    <Navigate to="/auth" state={{ from: location }} />
  );

PrivateRoute.propTypes = {
  element: PropTypes.any.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect((state) => ({ isAuthenticated: state.currentUser.isAuthenticated }))(
  PrivateRoute,
);
